import { useTranslation } from 'react-i18next';

import { Flex, LeftDrawerCollapseOutline, Text } from '@bonusly/design-system';

import { BIZY_CHAT_HEADER_HEIGHT, BizyHeaderIconButton } from '../bizy-side-panel-header';
import { useBizySidePanelStore } from '../store/use-bizy-side-panel-store';
import { BizyPeopleBrowserBody } from './bizy-people-browser-body';

// Fullscreen left-sidebar People Browser (BIZY-636). Thin container around the
// shared body so the fullscreen sidebar and the compact navigation menu render
// identical content, plus a header with a collapse control (BIZY-665).

export function BizyPeopleBrowser() {
	const { t } = useTranslation('admin_bizy');
	const togglePeopleBrowserCollapsed = useBizySidePanelStore((state) => state.togglePeopleBrowserCollapsed);

	return (
		<Flex data-component="bizy-people-browser" direction="column" h="100%" minH={0}>
			{/* Same height as the chat header so the two titles line up, and so the
			    leftover centring slack doesn't inflate the gap to the first nav row. */}
			<Flex align="center" justify="space-between" pl={5} pr={3} py={3} minH={BIZY_CHAT_HEADER_HEIGHT} flexShrink={0}>
				<Text fontSize="md" fontWeight="semibold" color="text.default">
					{t('menu.title')}
				</Text>
				<BizyHeaderIconButton label={t('sidePanel.closeBizyMenu')} icon={<LeftDrawerCollapseOutline boxSize={5} />} onClick={togglePeopleBrowserCollapsed} />
			</Flex>
			<BizyPeopleBrowserBody />
		</Flex>
	);
}
